import '.am{position:relative;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.h3{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ab{justify-content:center;}.ssr-plugin'
import '.av{align-items:flex-start;}.ssr-plugin'
import '.d4{padding:2rem;}.ssr-plugin'
import '.e2{background:var(--palette-white);}.ssr-plugin'
import '.c1{overflow:hidden;}.ssr-plugin'
import '.bg{position:absolute;}.ssr-plugin'
import '.jj{top:50%;}.ssr-plugin'
import '.jk{right:1rem;}.ssr-plugin'
import '.jl{transform:translateY(-50%);}.ssr-plugin'
import '.jm{width:120px;}.ssr-plugin'
import '.jn{height:120px;}.ssr-plugin'
import '.jo{z-index:0;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.iu{z-index:1;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.jp{max-width:calc(100% - 140px);}.ssr-plugin'
import '.jq{font-size:4rem;}.ssr-plugin'
import '.dg{font-weight:700;}.ssr-plugin'
import '.jr{line-height:100%;}.ssr-plugin'
import '.gu{margin:0px;}.ssr-plugin'
import '.a3{color:var(--brand-secondary);}.ssr-plugin'
import '.a4{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="am n h3 a b ab av d4 e2 c1"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="bg jj jk jl jm jn jo a r ab"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="am iu a b av s jp"
      >
        <div className="jq dg jr gu a3 a4"
        >
          {number}
        </div>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
